import { Box, Stack, Typography } from '@dtx-company/design-system/src'
import Image from 'next/image'
import { FC } from 'react'
import { ComplianceBadgesGrid } from './ComplianceBadgesGrid'
import { FooterLink } from './FooterLink'
import { FooterLoggedOutSocialLinks } from './FooterLoggedOutSocialLinks'
import { FooterTrademarkNotice } from './FooterTrademarkNotice'

export const LoggedOutGeneratorFooter: FC = () => {
  return (
    <Stack
      component="footer"
      sx={theme => ({
        gridArea: 'footer',
        backgroundColor: '#232323',
        p: { xs: 4, lg: 6 },
        '& p': {
          color: theme.palette.surface[1]
        }
      })}
      gap={{ md: 8, lg: 16 }}
    >
      <Typography variant="bodySmall" component="p" textAlign={{ xs: 'center', md: 'left' }}>
        Join the 20,000+ businesses building with Flowcode
      </Typography>
      <Box
        sx={theme => ({
          width: '100%',
          height: { xs: theme.spacing(44), md: theme.spacing(51) },
          position: 'relative'
        })}
      >
        <Image src="/logos/flowcode-footer-logo.svg" alt="Flowcode logo" fill objectFit="contain" />
      </Box>
      <Stack
        alignItems="flex-start"
        justifyContent="space-between"
        sx={{ flexDirection: { md: 'column', lg: 'row' }, gap: { xs: 8, lg: 0 } }}
      >
        <FooterLink />
        <ComplianceBadgesGrid />
        <Box
          sx={{
            display: { md: 'none', lg: 'block' },
            position: 'relative',
            maxWidth: { xs: '100%', lg: 280, xl: 300 },
            width: '100%',
            height: { xs: '138px', lg: '106px' }
          }}
        >
          <Image
            src="/graphics/footer-medals.png"
            alt="Industry awards and recognition"
            fill
            style={{ objectFit: 'contain' }}
          />
        </Box>
      </Stack>
      <Stack
        gap={4}
        justifyContent="space-between"
        sx={{
          mt: 12,
          width: '100%',
          flexWrap: 'wrap',
          flexDirection: { md: 'column', lg: 'row' }
        }}
      >
        <Stack direction="row" alignItems="center" gap={3} flexWrap="wrap">
          <FooterTrademarkNotice />
          <Typography variant="labelSmall" component="p" sx={{ m: 0, color: 'inherit' }}>
            ©2026 the dx company
          </Typography>
        </Stack>
        <FooterLoggedOutSocialLinks />
      </Stack>
    </Stack>
  )
}
